import type { FaqState } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';

const initialFaqState: FaqState = {
  faqItems: [],
};

export default initialFaqState;
